module.exports = __webpack_public_path__ + "media/images/logo_jouwweb-c4ca27e057a341acaee50f54af03fcdc.svg";